module.exports = __webpack_public_path__ + "img/logo.16279822.png";